import * as types from './constants';

// Get Creator Details
export const getShopifyTokenRequest = data => (
  { type: types.GET_SHOPIFY_TOKEN_REQUEST, payload: data }
);

export const getShopifyTokenDone = data => (
  { type: types.GET_SHOPIFY_TOKEN_DONE, payload: data }
);

export const getShopifyTokenFailed = errors => (
  { type: types.GET_SHOPIFY_TOKEN_FAILED, payload: errors }
);
export const getShopifyTokenReset = () => (
  { type: types.GET_SHOPIFY_TOKEN_RESET }
);
